import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Form,
  Input,
  Typography,
  Row,
  Col,
  Image,
  Layout,
  notification,
  Card,
} from "antd";
import "./login.css"; // Optional: Custom styles
import { useSelector, useDispatch } from "react-redux";
import actions from "../redux/Login/actions";
import config from "../Services/apiEndPoints";
import { isEmpty, isUndefined } from "lodash";
import StyledButton from "../Utils/styledButton";
import StyledCard from "../Utils/styledCard";
import BackgroundImage from "../Utils/styledBackgroundImage";

const { Title } = Typography;
const { Header } = Layout;

export default function Login() {
  const [loginForm] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const typeOfUser = location.pathname.split("logIn/")[1] || "existingUser";

  useEffect(() => {
    if (!isEmpty(typeOfUser) && !isUndefined(typeOfUser)) {
      loginForm.setFieldsValue({
        mobileNumber: "",
      });

      // localStorage.clear();
      // sessionStorage.clear();
      localStorage.setItem("typeOfUser", typeOfUser);
      sessionStorage.setItem("typeOfUser", typeOfUser);
    }
  }, [typeOfUser]);

  const [mobile, setMobile] = useState("");
  const { successMessage, errorMessage, actionType } = useSelector(
    (state) => state.logIn
  );

  const mobileNum = localStorage.getItem("mobileNumber");

  useEffect(() => {
    loginForm.setFieldsValue({
      mobileNumber: mobileNum,
    });
  }, []);

  useEffect(() => {
    if (actionType === actions.LOGIN_SUCCESS && successMessage) {
      notification.success({
        message: successMessage,
      });
      navigate("/otpScreen");
      dispatch(actions.resetActionType());
    } else if (actionType === actions.LOGIN_ERROR && errorMessage) {
      // notification.error({
      //   message: errorMessage,
      // });
      if (errorMessage === "User not found.") {
        // console.log(errorMessage)
        navigate("/newuser");
      }
      dispatch(actions.resetActionType());
    }
  }, [actionType, successMessage, errorMessage]);

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobile(value);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await loginForm.validateFields();
      const payload = {
        mobileNumber: "+91" + values?.mobileNumber,
      };
      if (typeOfUser === "existingUser") {
        payload["type"] = "login";
      }
      localStorage.setItem("mobileNumber", values.mobileNumber);
      dispatch(actions.login(config.logIn, payload));
    } catch (e) {
      console.log("error", e);
    }
  };

  const capitalizeFirstLetter = (title) => {
    if (isEmpty(title)) return "";
    return title.charAt(0).toUpperCase() + title.slice(1);
  };

  return (
    <div>
      <div
        style={{
          backgroundColor: "rgba(255, 165, 0, 0.8)",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

        }}

      >
        <Card
          style={{
            maxWidth: "400px",
            width: "100%",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src="/favicon.ico"
              alt="Logo"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>
          <h3 style={{textAlign:"center"}}>Login</h3>
<p style={{marginLeft:"15px"}}>Mobile Number</p>
          <Form
            name="login"
            form={loginForm}
            layout="vertical"
            style={{ padding: "0 15px" }}
          >
          <Form.Item
              name="mobileNumber"
              rules={[
                {
                  required: true,
                  message: "Mobile number is required.",
                },
                {
                  pattern: /^[6-9]\d{9}$/,
                  message: "Please enter valid mobile number.",
                },
              ]}
            >
              <Input
      addonBefore="+91"
      placeholder="Enter Mobile Number"
      onChange={handleMobileChange}
      type="tel"  // 💡 Changed from "text" to "tel"
      inputMode="numeric" // 💡 Ensures only numbers are entered
      pattern="[0-9]*" // 💡 Restricts input to only numbers
      maxLength={10}
      size="large"
    />
            </Form.Item>
            <Form.Item>
              <StyledButton
                onClick={handleSubmit}
                style={{
                  width: "100%",
                  height: "40px",
                  fontSize: "16px",
                  fontWeight: "500",
                  backgroundColor: "#ff8c00",
                  borderColor: "#ff8c00",
                }}
              >
                Send OTP
              </StyledButton>
            </Form.Item>
          </Form>
          <div style={{ textAlign: "center", marginTop: "15px" }}>
            <a
              href="https://sriramanavami.com/"
              style={{
                textDecoration: "none",
                color: "#007bff",
                fontSize: "14px",
              }}
            >
              ⬅ Back to Home
            </a>
          </div>
        </Card>
      </div>
    </div>
  );
}
